import gql from 'graphql-tag';
import CheckFragment from './CheckFragment';

const OrderFragment = gql`
  fragment Order on Order {
    openedDate
    closedDate
    subtotal
    discountTotal
    tax
    total
    void
    voidReason
    altPaidAmount
    altRefundedAmount
    autoSend
    cardPaidAmount
    cardGratuityAmount
    cashAppliedAmount
    cashierUserId
    cashierUserName
    cashPaidAmount
    changeAmount
    checkCount
    changeAmount
    closingDevice
    discountValue
    orderStatus
    kitchenStatus
    giftCertificateAmount
    gratuityPercentage
    gratuityAmount
    guestCount
    id
    includedTax
    lastModifiedDate
    lastModifiedDevice
    lastModifiedRegisterName
    lastModifiedTimestamp
    location
    locationId
    openingDevice
    pushedTimestamp
    refundedAmount
    refundedCardAmount
    refundedGiftCardAmount
    reopenRefund
    register
    registerName
    revenueCenterId
    roundingAmount
    sendToKitchen
    serverUserName
    tabName
    tableName
    togoStatus
    checks {
      ...Check
    }
  }

  ${CheckFragment}
`;

export default OrderFragment;


// WEBPACK FOOTER //
// ./src/graphql/fragments/order/OrderFragment.js